<template>
  <div id="keyWordList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <input class="allInput" placeholder="关键字" type="text" v-model="searchData.keyWords">
          </p>
          <button class="redButton" @click="getKeyWordList(1)">搜索</button>
        </div>
        <div style="width: auto">
          <button class="redButtonTwo" @click="addNewKeyWord">新建</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <table cellspacing="0" class="allTable">
          <thead>
            <tr>
              <th>关键字</th>
              <th>回复内容</th>
              <th>创建人</th>
              <th>创建时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="keyWordList.length >0">
              <tr :key="index" v-for="(item, index) in keyWordList">
                <td width="15%" class="NoWrap" :title="item.keyWords">{{item.keyWords}}</td>
                <td width="40%" class="NoWrap" :title="item.content" style="max-width: 680px;">{{item.content}}</td>
                <td width="15%" :title="item.createName">{{item.createName}}</td>
                <td width="15%" >{{item.createTime ? $commonJs.returnNewDate(item.createTime) : ''}}</td>
                <td width="15%">
                  <div v-if="item.createId == userInfo.id" class="icon more iconfont icongengduo moreOperations">
                    <ul>
                      <li @click="editListItem(item)">编辑</li>
                      <li @click="deleteListItem(item)">删除</li>
                    </ul>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td style="border: none; text-align: center;" :colspan="5">暂无数据</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getKeyWordList($event)" :totalPage="totalPage" :page="searchData.PageIndex" :explain="0"></page>
    </div>
    <!-- 新增、编辑关键字 -->
    <model v-if="showModel" :buttonType="0" :title="modalTitle" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
        <ul class="allUL">
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>关键字</span>
            <input maxlength="50" v-model="modelData.keyWords" type="text" class="allInput" style="width: calc(100% - 110px); margin-left: -30px;" placeholder="请输入关键字" />
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>回复内容</span>
            <textarea maxlength="200"  v-model="modelData.content" class="allTextarea" style="width: calc(100% - 120px); margin-left: -30px;" name="" id="" cols="30" rows="10" placeholder="请输入回复内容"></textarea>
          </li>
        </ul>
      </div>
    </model>
  </div>
</template>

<script>
let Time
  export default {
    name: 'keyWordList',
    data () {
      return {
        userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
        keyWordList: [],
        totalPage: 0,
        totalCount: 0,
        searchData: {
          PageSize: 10,
          PageIndex: 1,
          keyWords: ''
        },
        modalTitle: '',
        showModel: false,
        modelData: {
          keyWords: '',
          content: '',
          id: 0,
        },
      }
    },
    created () {
      // 获取关键字列表
      this.getKeyWordList(1)
    },
    methods: {
      // 获取关键字列表
      getKeyWordList (page) {
        this.searchData.PageIndex = page
        let params = {
          pageIndex: this.searchData.PageIndex,
          pageSize: this.searchData.PageSize
        }
        this.$axiox.post(`/api/WechatAutoReply/QueryAutoReply?keyWords=${this.searchData.keyWords}`, params).then(res => {
          console.log(res, 'getKeyWordList')
          if (res.data && res.data.length > 0) {
            this.keyWordList = res.data
            this.totalPage = Math.ceil(res.total / this.searchData.PageSize)
            this.totalCount = res.total
          } else {
            this.keyWordList =[]
            this.totalPage = 0
            this.totalCount = 0
          }
        })
      },
      getKeyWordById (item) {
        this.$axiox.get(`/api/WechatAutoReply/GetAutoReply?id=${item.id}`).then(res => {
          console.log(res, 'getKeyWordById')
          this.modelData.keyWords = res.keyWords
          this.modelData.content = res.content
        })
      },
      addNewKeyWord () {
        this.modalTitle = '新增关键字'
        this.modelData.id = 0
        this.showModel = true
      },
      confirModel () {
        this.modelData.keyWords = this.modelData.keyWords.trim()
        this.modelData.content = this.modelData.content.trim()
        if (!this.modelData.keyWords || !this.modelData.content) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
          return
        }
        if (this.modelData.id == 0) {
          let params = {
            keyWords: this.modelData.keyWords,
            content: this.modelData.content
          }
          this.$axiox.post(`/api/WechatAutoReply/AddAutoReply`, params).then(res => {
            console.log(res, '新增')
            this.showModel = false
            this.modelData.keyWords = ''
            this.modelData.content = ''
            this.modelData.id = 0
            this.modalTitle = ''
            this.getKeyWordList(1)
          })
        } else {
          let params = {
            id: this.modelData.id,
            keyWords: this.modelData.keyWords,
            content: this.modelData.content,
          }
          this.$axiox.put(`/api/WechatAutoReply/UpdateAutoReply`, params).then(res => {
            console.log(res, '编辑')
            this.showModel = false
            this.modelData.keyWords = ''
            this.modelData.content = ''
            this.modelData.id = 0
            this.modalTitle = ''
            this.getKeyWordList(1)
          })
        }
      },
      cancelModel () {
        this.showModel = false
        this.modelData.keyWords = ''
        this.modelData.content = ''
        this.modelData.id = 0
        this.modalTitle = ''
      },
      editListItem (item) {
        this.modalTitle = '编辑关键字'
        this.modelData.id = item.id
        this.showModel = true
        this.getKeyWordById(item)
      },
      deleteListItem (item) {
        console.log(item, 'deleteListItem')
        this.$commonJs.doubleComfirm({
          content: '是否确定删除此关键字？',
          successFun: () => {
            this.$axiox.del('/api/WechatAutoReply/DelAutoReply/' + item.id).then(res => {
              this.$commonJs.alertTips({
                type: 'success',
                title: '成功',
                content: '删除成功',
                stayTime: 5
              })
              this.getKeyWordList(1)
            })
          },
          errorFun: err => {
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/autoReplyManager/keyWordList.vue